module.exports = __webpack_public_path__ + "static/media/10.question.b51d0809.mp4";